import React from 'react';
import './styles.css';
import { SettingOutlined } from '@ant-design/icons';

const WorkingMessage = () => {

  return(
    <div className="working-message-container">
      <div className="icon-wrapper">
        <SettingOutlined spin/>
      </div>
      <div className="text-wrapper">
        <h2>
          Estamos trabajando en nuevas funcionalidades para mejorar tu experiencia.
        </h2>
      </div>
    </div>
  )
}

export default WorkingMessage;